// extracted by mini-css-extract-plugin
export default {"airplaneSizingContainer":"Aaa-z","narrowOptionButtons":"Baa-z","noOptions":"Caa-z"};